/* YAFÉ — Brand Story Band
   Staggered reveal on scroll. Reduced-motion aware, theme-editor safe. */

(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStory(root) {
    if (root.dataset.yafeInit === 'true') return;
    root.dataset.yafeInit = 'true';

    if (reduceMotion || !('IntersectionObserver' in window)) {
      root.classList.add('is-revealed');
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(function () {
            root.classList.add('is-revealed');
          });
          obs.disconnect();
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-yafe-story]');
    Array.prototype.forEach.call(roots, initStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-yafe-story]');
    if (root) root.classList.add('is-revealed');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-yafe-story]');
    if (root) root.classList.add('is-revealed');
  });
})();
